module.exports = vendor_e3648d318b02051b7324;